import {Injectable} from '@angular/core';
import {Http, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend} from '@angular/http';
import {ErrorMessage} from '@catloader/loader-service/types';
import {getFactory} from '@catloader/loader-service/utils/webapi-error-helper';
import {NotificationsService} from 'app/modules/core/services/index';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {LoaderService} from './loader.service';

/**
 * A middleware for the Http service to handle requests before passed through to other services
 *
 * This middleware is used to tell the LoaderService if active requests are currently processed.
 *
 * @deprecated
 */
@Injectable()
export class HttpService extends Http {
  public pendingRequests = 0;
  public showLoading = false;
  private errorMessageFactory;

  constructor(backend: XHRBackend,
              defaultOptions: RequestOptions,
              protected notificationService: NotificationsService,
              protected loaderService: LoaderService) {
    super(backend, defaultOptions);
    this.errorMessageFactory = getFactory();
  }

  request(url: string | Request, options ?: RequestOptionsArgs): Observable<Response> {
    return this.intercept(super.request(url, options));
  }

  private intercept(observable: Observable<Response>): Observable<Response> {
    this.pendingRequests++;
    this.loaderService.show();
    return observable
      .catch((err, source) => {
        console.log('Caught error: ' + err, source);

        this.errorMessageFactory
          .forLegacyHttpResponse(err)
          .forEach((message: ErrorMessage) => {
            this.notificationService.error(message.title, message.message);
          });

        return [];
      })
      .do((res: Response) => {
        console.log('Response: ' + res);
      }, (err: any) => {
        console.log('Caught error: ' + err);
      })
      .finally(() => {
        console.log('Finally.. delaying, though.');
        this.pendingRequests--;

        if (this.pendingRequests <= 0) {
          this.loaderService.hide();
        }
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/services/http.service.ts